<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Leads</li>
        </ol>

        <v-card>
          <div class="row filtros">
            <div class="col-md-2">
              <div class="form-group">
                <label>Selecione um tipo</label>
                <select class="form-control" @change="e => tipoLead = e.target.value" v-model="tipoLead">
                  <option value="qualificado">Qualificado</option>
                  <option value="quente">Quente</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione a data de início</label>
                <date-picker
                  v-model="dataFiltro.inicio"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de inicio"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione a data de fim</label>
                <date-picker
                  v-model="dataFiltro.fim"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de fim"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Selecione um status</label>
                <select @change="e => statusLead = e.target.value" class="form-control" v-model="statusLead">
                  <option value="0" selected>Ativadas</option>
                  <option value="1" selected>Todas</option>
                </select>
              </div>
            </div>
            <div class="col-md-2 btns_center">
                  <button
                  class="btn_1 medium pull-right"
                  @click="filtraLead"
                >Filtrar</button>
            </div>
              
          </div>
          <v-card-title>
            <h3>Leads</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :no-data-text="textoTabela" :headers="headers" :items="leads" :search="search" :pagination.sync="pagination">
            <template slot="items" slot-scope="props" v-if="!(props.item.deleted_at) || statusLead">
              <td>{{ props.item.id}}</td>
              <td>{{ props.item.nome}}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.telefone }}</td>
              <td>{{ padronizaData(props.item.created_at) }} {{ padronizaHora(props.item.updated_at) }}</td>
              <td>{{ props.item.planos }}</td>
              <td> R$ {{ props.item.total ? (props.item.total.toFixed(2)).toString().replace(".", ",") : '0,00' }} </td>
              <td class="text-xs-right botoes" >
                <span v-if="(props.item.subscribers_id && tipoLeadFiltrado != 'qualificado')" class="btn_1 gray delete wishlist_close mt-1 mb-1 button-content" @click="() => {
                    $bvModal.show('modalCorretor');
                    lead_id = props.item.id;
                    props.item.corretores_id ? corretor = props.item.corretores_id : corretor = 0;
                  }">
                    <i class="fa fa-fw fa-edit icon-left"></i> {{props.item.corretores_id ? 'Trocar' : 'Vincular'}}
                </span>
                <span v-if="!(props.item.deleted_at)" class="btn_1 red delete wishlist_close mb-1 button-content" @click="() => {$bvModal.show('modalInativacao');leadInativando = props.item}">
                    <i class="fa fa-times"></i> Inativar
                </span>
                <span v-else class="btn_1 blue delete wishlist_close mb-1 button-content" @click="ativalead(props.item)">
                    <i class="fa fa-check"></i> Ativar
                </span> 
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>

    <!-- Modal Component -->
    <b-modal
      id="modalCorretor"
      title="Corretores"
      centered
      ok-title="Salvar"
      ok-only
      @ok="selecionaCorretor"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Corretores</label>
            <select class="form-control" v-model="corretor">
              <template v-for="ct in corretores">
                <option value=0 selected disabled hidden v-bind:key="ct.nome_completo">Escolha um corretor</option>
                <option :key="ct.id" :id="ct.id" :value="`${ct.id}`">
                  {{`${ct.nome_completo}`}}
                </option>
              </template>
            </select>
          </div>
        </div>
        <hr>
      </div>
    </b-modal>

    <b-modal
      id="modalInativacao"
      title="Inativando Lead"
      centered
      ok-title="Inativar"
      ok-only
      @ok="() => {
        desativalead(leadInativando)
      }"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Status da Lead</label>
            <select class="form-control" v-model="statusLeadInativando">
                <option value=0 selected disabled hidden>Escolha um status</option>
                <option value="em_andamento"> Em andamento </option>
                <option value="vendido"> Vendido </option>
                <option value="perdido"> Perdido </option>
            </select>
          </div>
          <div class="form-group" v-if="statusLeadInativando == 'perdido'">
            <label>Motivo</label>
            <input type="text" class="form-control" maxlength="24" v-model="motivoLeadInativando">
          </div>
        </div>
        <hr>
      </div>
    </b-modal>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao, alerta, padronizaDataUS } from "@/utils/util";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      lang: {
        days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        months: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dec"
        ],
        pickers: [
          "prox 7 dias",
          "prox 30 dias",
          "7 dias anteriores",
          "30 dias anteriores"
        ],
        placeholder: {
          date: "Selecione a data",
          dateRange: "Selecione o intervalo"
        }
      },
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "nome" },
        { text: "E-Mail", value: "email"},
        { text: "Telefone", value: "telefone"},
        { text: "Data de atualização", value: "updated_at" },
        { text: "Planos", value: "planos" },
        { text: "Total", value: "total" },
        { text: "", value: "" },
      ],
      pagination: { sortBy: "updated_at", descending: true },
      leads: [
        {
          corretor: null
        }
      ],
      corretores: [],
      lead_id: null,
      corretor: 0,
      statusLead: 0,
      tipoLead: "qualificado",
      tipoLeadFiltrado: "qualificado",
      dataFiltro: {
        inicio: "",
        fim: "",
      },
      isLoading: false,
      leadInativando: null,
      statusLeadInativando: '0',
      motivoLeadInativando: '',
    };
  },
  mounted() {
     var self = this;
     self.isLoading = true;
      
     ajax("get", "/leads/1/0/0/qualificado")
       .then(response => {
         self.isLoading = false;
         self.leads = response;
         self.leads.map((ld) => {
          let total = 0;
          let planos = "";
          ld.carrinho.forEach(car => {
            planos = planos + car.quantidade + " x " + car.name + ", ";
            total += (car.price/100) * car.quantidade;
          });
          ld.planos = planos.substring(0, planos.length-2)
          ld.total = total;
         })
       })
       .catch(error => {
         self.isLoading = false;
         tratamento_requisicao(error, this);
       });
      ajax("get", "/corretores")
      .then((corretoresRes) => {
        self.corretores = corretoresRes;
        self.corretores.map((corretor) => {
            corretor.nome_completo = `${corretor.name} ${corretor.last_name}`
        })
        self.isLoading = false;
      }).catch((err) => {
          self.isLoading = false;
          tratamento_requisicao(err, this);
      });
   
  },
  methods: {
    selecionaCorretor(){
      let self = this;
      let lead = self.leads.find((ld) => ld.id == self.lead_id);
      ajax("put", `assinantes/${lead.subscribers_id}`, {corretores_id: parseInt(self.corretor)})
      .then(response => {
        self.leads.map((ld) => {
          if(ld.id == lead.id) ld.corretores_id = self.corretor;
        })
        self.corretor = 0;
        self.isLoading = false;
        alerta(
        "success",
        "Ativado",
        "Corretor vinculado com sucesso!"
        );
      })
      .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
      });
    },
    desativalead(lead){
      let self = this;
      //self.isLoading = true;
      const novaData = new Date();      
      const obj = {
        id: lead.id,
        status: self.statusLeadInativando,
        motivo: self.motivoLeadInativando,
        deleted_at: padronizaDataUS(novaData.toLocaleDateString()) + " " + novaData.toLocaleTimeString(),
      }
      if(self.statusLeadInativando != '0'){
        ajax("put", "leads/" + obj.id, obj)
        .then(response => {
            let indexItemRemovido = self.leads.findIndex(
            x => x.id == lead.id
            );
            self.leads[indexItemRemovido].deleted_at = 1;
            if(self.statusLead == '0')
                self.leads = self.leads.filter((ld) => (ld.deleted_at != 1))
            self.isLoading = false;
            alerta(
            "success",
            "Inativado",
            "Lead inativada com sucesso!"
            );
            self.leadInativando = null;
            self.statusLeadInativando = '0';
            self.motivoLeadInativando = '';
        })
        .catch(error => {
            self.isLoading = false;
            self.leadInativando = null;
            self.statusLeadInativando = '0';
            self.motivoLeadInativando = '';
            tratamento_requisicao(error, this);
        });
      } else {
        alerta(
        "error",
        "Erro",
        "Verifique se os campos estão preenchidos!"
        );
      }
    },
    ativalead(lead){
        let self = this;
        self.isLoading = true;
        const obj = {
          id: lead.id,
          status: 'em_andamento',
          motivo: '',
          deleted_at: null,
        }

        ajax("put", "leads/"+lead.id, obj)
        .then(response => {
            let indexItemRemovido = self.leads.findIndex(
                x => x.id == lead.id
            );
            self.leads[indexItemRemovido].deleted_at = null;
            self.isLoading = false;
            alerta(
            "success",
            "Ativado",
            "Lead ativada com sucesso!"
            );
        })
        .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error, this);
        });
    },
    filtraLead(e){
      var self = this;
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      self.tipoLeadFiltrado = self.tipoLead;
      self.isLoading = true;
      let inicio = "";
      let fim = "";
      self.dataFiltro.inicio ? inicio = padronizaDataUS(self.dataFiltro.inicio) : inicio = 0;
      self.dataFiltro.fim ? fim = padronizaDataUS(self.dataFiltro.fim) : fim = 0;
      ajax("get", `/leads/${self.statusLead}/${inicio}/${fim}/${self.tipoLead}`)
        .then((response) => {
          self.isLoading = false;
          self.isLoading = false;
          self.leads = response;
          self.leads.map((ld) => {
            let total = 0;
            let planos = "";
            ld.carrinho ? ld.carrinho.forEach(car => {
              planos = planos + car.quantidade + " x " + car.name + ", ";
              total += (car.price/100) * car.quantidade;
            }) : null;
            ld.planos = planos.substring(0, planos.length-2)
            ld.total = total;
          })
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    changeStatusLead(event) {
        let self = this;
        if(self.statusLead == 0){
            self.isLoading = true;
            ajax("get", "/leads")
            .then(response => {
              self.isLoading = false;
              self.leads = response;
              self.leads.map((ld) => {
                let total = 0;
                let planos = "";
                ld.carrinho.forEach(car => {
                  planos = planos + car.quantidade + " x " + car.name + ", ";
                  total += (car.price/100) * car.quantidade;
                });
                ld.planos = planos.substring(0, planos.length-2)
                ld.total = total;
              })
            })
            .catch(error => {
                self.isLoading = false;
                tratamento_requisicao(error, this);
            });
        } else {
            self.isLoading = true;
            ajax("get", "/leads_with_trashed")
            .then(response => {
              self.isLoading = false;
              self.leads = response;
              self.leads.map((ld) => {
                let total = 0;
                let planos = "";
                ld.carrinho.forEach(car => {
                  planos = planos + car.quantidade + " x " + car.name + ", ";
                  total += (car.price/100) * car.quantidade;
                });
                ld.planos = planos.substring(0, planos.length-2)
                ld.total = total;
              })
            })
            .catch(error => {
                self.isLoading = false;
                tratamento_requisicao(error, this);
            });
        }
    },
  }
};
</script>
<style>
    .select-lead {
        margin-top: 1em;
        margin-bottom: 1em;
    }
    .button-content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-around;
    }
    @media (min-width: 1650px) {
      .botoes{
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-end;
      }
    }
</style>